import moment from "moment";

 export function numberAsMoney(number) {
     /**
      * Format number to money figures
      *
      * This function takes @param number and convert it to money figures and
      * appending the '₦' to it e.g 1000 will be ₦1,000
      *
      * @param {Number} number the number to be formatted
      *
      * @returns {Number} the formatted @param number
      */
     number = parseFloat(number || 0)
     if (number) {
         let money = '₦' + number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
         if (money.includes('-')) {
             money = money.replace('-', '')
             money = '-' + money
         }
         return money
     } else {
         return '₦0.00'
     }
 }
 
 export function copy(obj) {
     /**
      * Used to prevent passing by reference
      *
      * JavaScript by default passes data as reference, this function is used to prevent such behavior
      *
      * @param {Object} obj the json to work with
      *
      * @returns {Object} the json without the passing by reference
      */
     return JSON.parse(JSON.stringify(obj))
 }
 
 export function generate_id(...prefixes) {
     /**
      * An ID has 4 sections <year><month>:<user_prefix><date>, the datatype to be stored, e.g all items starts withthesame
      * character.
      */
     const epoch_beginning = 1594993552178 // date software was coded
     let timestamp = Date.now() - epoch_beginning
     let date_string = base10_to_base62(timestamp)
 
     let year_prefix = new Date().getFullYear()
     year_prefix = year_prefix.toString().slice(-2)
     year_prefix = base10_to_base62(year_prefix) + base10_to_base62(new Date().getMonth())
 
     return `${year_prefix}:${prefixes.join('')}${date_string}`
 }
 
 /**
  * Converts a decimal number to base62.
  * @param num {Number} -> The decimal number to be converted.
  * @return {string}
  *
  * e.g 1 = 1, 10 = a, 16 = f, 61 = Z, etc
  */
 export function base10_to_base62(num) {
     num = parseInt(num)
     const order = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
     const base = order.length
     let str = ""
     let r
     while (num) {
         r = num % base
         num = Math.floor(num / base)
         str = order.charAt(r) + str
     }
     return str + ''
 }
 
 export function moneyFormat(number) {
     return numberAsMoney(number)
 }
 
 export function dateFormat(date, format = 'Do MMMM, YYYY h:ma') {
     return moment(date).format(format)
 }
 
 export function flattenObject(obj, parent, res = {}) {
     for (let key in obj) {
         let propName = parent ? parent + '.' + key : key;
         if (typeof obj[key] == 'object') {
             flattenObject(obj[key], propName, res);
         }
         res[propName] = obj[key];
     }
     return res;
 }
 
 export const replacePlaceholders = function replacePlaceholders (source, obj) {
     let parseJson = false
     if (typeof source === 'object') {
         source = JSON.stringify(source)
         parseJson = true
     }
     const placeholders = source.match(/:[.#a-z_-]+(?<!~:[.#a-z_-]+)/g) || []
     obj = flattenObject(obj)
     placeholders.map(placeholder => {
         let replacement = obj[placeholder.substr(1)]
         if (typeof replacement === 'object') {
             replacement = JSON.stringify(replacement)
             if (parseJson) {
                 placeholder = `"${placeholder}"`
             }
         }
         source = source.replace(placeholder, replacement)
     })
     source = source.replace(/~:/g, ":")
     if (parseJson) {
         source = JSON.parse(source)
     }
     return source
 }
 
 export function  retrieve_accumulator_id (storageKey, user={}, placeholder={}) {
     let _id = `accumulator:`
     if (typeof storageKey === "object") {
         if (storageKey.scope) {
             if (typeof storageKey.scope === "string") {
                 storageKey.scope = [storageKey.scope]
             }
             _id += storageKey.scope.map(scope => {
                 switch (scope) {
                     case 'user':
                         return user._id.replace('org.couchdb.user:', '')
                     case 'role':
                         return user.meta._id
                     case 'year':
                         return new Date().getUTCFullYear()
                     case 'month':
                         return new Date().getUTCMonth() + 1
                     case 'date':
                         return new Date().getUTCDate()
                     case 'day':
                         return new Date().getUTCDay()
                     default:
                         return scope
                 }
             }).join(':') + ":"
         }
         _id += storageKey.key
     } else {
         _id += replacePlaceholders(storageKey, placeholder)
     }
     return _id
 }
 